import request from '@/utils/request'

export function fetchContentList(data) {
  return request({
    url: '/v1/contents/fe-list',
    method: 'get',
    params: data
  })
}

export function fetchContentDetail(data) {
  return request({
    url: '/v1/contents/fe-detail',
    method: 'post',
    data
  })
}
